import {
  FormSectionConfigDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORM_SECTIONS_CONFIG } from "../domain";

import { formsSectionsConfigApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_FORM_SECTION_CONFIG = "GET_FORM_SECTION_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

export const fetchFormSectionConfigDetails = async (
  sectionId: string,
): Promise<FormSectionConfigDto> => {
  const response =
    await formsSectionsConfigApi.formSectionsConfigControllerGetFormSectionConfigDetail(
      sectionId,
    );

  return response.data;
};

export const useGetFormSectionConfigDetails = (
  user: UserProfileDto | null,
  sectionId: string,
  enable: boolean = true,
): {
  formSectionConfigDetails: FormSectionConfigDto | undefined;
  formSectionConfigDetailsEnabled: boolean;
  isLoadingFormSectionConfigDetails: boolean;
  isFetchingFormSectionConfigDetails: boolean;
  isSuccessFormSectionConfigDetails: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { data, isLoading, isFetching, isSuccess } = useQuery<
    FormSectionConfigDto,
    Error
  >({
    queryKey: [
      DOMAIN_FORM_SECTIONS_CONFIG,
      ACTION_GET_FORM_SECTION_CONFIG,
      sectionId,
    ],
    queryFn: () => fetchFormSectionConfigDetails(sectionId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    formSectionConfigDetails: data,
    formSectionConfigDetailsEnabled: enabled,
    isLoadingFormSectionConfigDetails: isLoading,
    isFetchingFormSectionConfigDetails: isFetching,
    isSuccessFormSectionConfigDetails: isSuccess,
  };
};
